const mapSelectionInclusionType = {
    INTERSECT: 'INTERSECT',
    CONTAIN: 'CONTAIN',
    CENTROID: 'CENTROID',
};

export default mapSelectionInclusionType;
